<tui-textfield tuiTextfieldSize="m" [tuiTextfieldCleaner]="false">
  <input
    tuiInputTime
    placeholder="00:00"
    [ngModel]="time"
    [disabled]="isDisabled"
    [readOnly]="$readOnly()"
    (ngModelChange)="onTimeChange($event)"
    (blur)="onTouched?.()"
  />
  @if (!$readOnly()) {
    <tui-data-list-wrapper
      *tuiDropdown
      [items]="$items() | tuiFilterByInput: filter"
    />
  }
</tui-textfield>
